/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InAppNotificationPriority } from './inAppNotificationPriority';


export interface InAppNotificationDto { 
    id?: number;
    title?: string | null;
    description?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    priority?: InAppNotificationPriority;
    isDraft?: boolean;
    active?: boolean;
    companyId?: number | null;
    companyName?: string | null;
}
export namespace InAppNotificationDto {
}


